var $ = jQuery.noConflict();

$(document).ready(function(){
    
    $('.page-vote .search button[type="submit"]').click(function(e){

        e.preventDefault()
        $(this).closest('form').submit();

    });

    $('.page-vote .filter select').on('select2:select', function (e) {

        $(this).closest('form').submit();

    });

    $('.page-vote .filter select').on('select2:clear', function (e) {

        $(this).closest('form').submit();

    });

    

    $('.page-vote .filter .btn').click(function(e){

        e.preventDefault();
        var value = $(this).attr('data-value');
        $('.sort .btn.active').removeClass('active');
        $(this).addClass('active');
        $(this).closest('form').find('input[name=sort]').val(value);
        $(this).closest('form').submit();

    });

});


// WEBPACK FOOTER //
// ./assets/js/filter.js